import React, { Component } from 'react';
import { GeckoCardTable, GeckoBtn, GeckoCard, GeckoCardHeader, GeckoCardBody, GeckoAlert } from '@geckolabs/gecko-react-ui';
import { connect } from 'react-redux';
import { $state, } from '../../router';
import Utils from '../../services/utils/utils';
import {__, STR_KEY} from '../../services/Translate';

export class EventsTable extends Component {

    cols = [{
        key   : 'title',
        name  : __(STR_KEY.EVENTS_PAGE_COL_TITLE),
        width : '45%'
    }, {
        key    : 'start_datetime',
        name   : __(STR_KEY.EVENTS_PAGE_COL_START_DATE),
        width  : '20%',
        render : (date) => Utils.prettyDate(date)
    }, {
        key    : 'end_datetime',
        name   : __(STR_KEY.EVENTS_PAGE_COL_END_DATE),
        width  : '20%',
        render : (date) => Utils.prettyDate(date)
    },{
        key   : 'options',
        name  : '',
        width : '15%',
        render: (value, row, col, index) => {
            return (
                <GeckoBtn 
                    name={__(STR_KEY.EVENTS_PAGE_BTN_INFO)}
                    id={`info-${row.id}`}
                    icon="info-circle"
                    ariaLabel="View more info about this event"
                    role="link"
                />
            )
        }
    }];

    rowHandler(row) {
        if (row && row.attendances && row.attendances[0]) {
            return $state.go('rsvp', {account_uuid: this.props.account.uuid, contact_uuid: this.props.contact.uuid, event_id: row.id});
        }
        return;
    }

    renderFallback() {
        return (
            <GeckoCard>
                <GeckoCardHeader name={this.props.name} />
                <GeckoCardBody padded>
                    <GeckoAlert type="warning">
                        {__(STR_KEY.EVENTS_PAGE_TABLE_FALLBACK)}
                    </GeckoAlert>
                </GeckoCardBody>
            </GeckoCard>
        );
    }

    render() {
        if (!this.props.rows.length) return this.renderFallback();

        //prettify date
        return (
            <div className="EventsTable">
                <GeckoCardTable 
                    name={this.props.name} 
                    cols={this.cols} 
                    rows={this.props.rows} 
                    rowHandler={this.rowHandler.bind(this)} 
                    renderFooter={false}
                />
            </div>
        );
    }
}

EventsTable.defaultProps = {
    rows: []
};

const mapStateToProps = (store) => {
    return {
        account: store.account,
        contact: store.contact,
        //event: store.event,
        //eventAttendance: store.eventAttendance,
        //sessionAttendances: store.sessionAttendances
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // updateStore: (data) => {
        //     // dispatch(updateAccount(data.account));
        //     // dispatch(updateContact(data.contact));
        //     // dispatch(updateEvent(data.event));
        //     dispatch(updateEventAttendance(data.eventAttendance));
        //     //dispatch(updateSessionAttendances(data.sessionAttendances));
        // },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EventsTable)